import { render, staticRenderFns } from "./ReportFilter.vue?vue&type=template&id=10856b24&scoped=true&"
import script from "./ReportFilter.vue?vue&type=script&lang=js&"
export * from "./ReportFilter.vue?vue&type=script&lang=js&"
import style0 from "./ReportFilter.vue?vue&type=style&index=0&id=10856b24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10856b24",
  null
  
)

export default component.exports